import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { DealerProfile } from '@app/domain/model/dealer-profile';
import { QueryReportsService } from '../../query-reports.service';
import { ReportType } from '@app/domain/model/report-type';
import { SpeciesIndustryReport } from './species-industry-report';
import { QueryReportType, QueryReportTypeClass } from '@app/feature/dealer/query-reports';
import { UserAuthority } from '@app/domain/model/user-authority';
import { AuthenticationService } from '@app/shared/services/authentication.service';

@Component({
  selector: 'app-query-reports-result-species-industry',
  styleUrls: ['./query-reports-result-species-industry.component.scss'],
  templateUrl: './query-reports-result-species-industry.component.html',
})
export class QueryReportsResultSpeciesIndustryComponent {

  @Input()
  profile: DealerProfile;

  @Input()
  report: SpeciesIndustryReport;

  @Input()
  queryReportType: QueryReportTypeClass;

  ReportType: typeof ReportType = ReportType;

  constructor(private activeModal: NgbActiveModal,
              private readonly queryReportsService: QueryReportsService,
              private authenticator: AuthenticationService) {
  }

  onCancel() {
    this.activeModal.dismiss();
  }

  onExport() {
    this.queryReportsService.xls(this.getDealerId() ? this.profile.id : null);
  }

  onPrint() {
    this.queryReportsService.print(this.getDealerId() ? this.profile.id : null);
  }

  isIndustry(): boolean {
    return this.queryReportType.value === QueryReportType.industry.value;
  }

  isSpecies(): boolean {
    return this.queryReportType.value === QueryReportType.species.value;
  }

  isPaq(): boolean {
    return this.report.purchaseType === ReportType.PAQ;
  }

  private getDealerId() {
    const executor = this.authenticator.getCurrentUser();
    return executor.hasAuthority(UserAuthority.DEALER_INFO) ? this.profile.id : null;
  }
}
